export default function mapLstTable(data) {
  return data.map((device, index) => {
    return {
      ...device,
      key: index + 1,
    };
  });
}
